import { render, staticRenderFns } from "./MentionStats.vue?vue&type=template&id=9947102c&scoped=true"
import script from "./MentionStats.vue?vue&type=script&lang=js"
export * from "./MentionStats.vue?vue&type=script&lang=js"
import style0 from "./MentionStats.vue?vue&type=style&index=0&id=9947102c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9947102c",
  null
  
)

export default component.exports